<!--
  The contents of this file are subject to the license and copyright
  detailed in the LICENSE_ATMIRE and NOTICE_ATMIRE files at the root of the source
  tree and available online at

  https://www.atmire.com/software-license/
 -->
<div *ngIf="suggestion" class="item-preview">
    <h5> {{'search.suggestions.preview.filter.heading'| translate:{suggestionFilter: suggestion.label} }}</h5>
    <div *ngIf="!(resultsRD$ | async)?.hasSucceeded">
        <ds-loading [showMessage]="false"></ds-loading>
    </div>
    <ng-container *ngIf="(resultsRD$ | async)?.hasSucceeded">
        <ul *ngIf="(resultsRD$ | async)?.payload?.page.length >= 0" class="list-unstyled thumb-font-0">
            <li *ngFor="let object of (resultsRD$ | async)?.payload?.page" class="mb-2">
                <ds-listable-object-component-loader [object]="object" [context]="context"></ds-listable-object-component-loader>
            </li>
        </ul>
        <div *ngIf="(resultsRD$ | async)?.payload?.page.length === 0">
            {{'search.suggestions.preview.filter.no-results'| translate}}
        </div>
    </ng-container>
</div>
